import {useEffect, useState} from "react";
import { useTranslation } from 'react-i18next';
import "./Booking.css";
import {toast, ToastContainer} from "react-toastify";
import LandPage from "../../../Component/common/LandPage/LandPage";
import Navbar from "../../../Component/common/Navbar/Navbar";
import Topbar from "../../../Component/common/Topbar/Topbar";
import Footer from "../../../Component/common/Footer/Footer";
import Modal from "../../../Component/custom/Modal/Modal.jsx";
import {AngleLeft, AngleRight, Check, NotAvailable} from "../../../Assets/SVGS";
import Icon from "../../../Component/common/Icon/Icon";
import SuccessModal from "../../../Component/custom/SuccessModal/SuccessModal";
import MyAppointments from "../../../Component/sections/MyAppointments/MyAppointments";
import getData from "../../../utils/getData";
import Loader from "../../../Component/common/Loader/Loader";
import TwoInputs from "../../../Component/common/TwoInputs/TwoInputs";
import handleApiError from "../../../utils/handleApiError";
import axios from "axios";
import base_url from "../../../config/base_url";
import { motion } from "framer-motion";
function Booking() {
  const { t } = useTranslation();
  const token = localStorage.getItem("token")
  const [confirmationLoader , setConfirmationLoader] = useState(false)
  const [totalDays , setTotalDays] = useState(0)
  const [dayPerPage , setdayPerPage] = useState(7);
  const [ startIndex , setStartIndex] = useState(0)
  let lastIndex = startIndex + dayPerPage
  let pageCounter = Math.ceil((totalDays-startIndex)/dayPerPage) + Math.ceil((startIndex-0)/dayPerPage)

  const [modal, setModal] = useState({
    confirmation: false,
    data: false,
    success: false,
  });
  
  const [appointment , setAppointment] = useState({
    day:null,
    hour:null
  })

  const [appointmentData , setAppointmentData] = useState({
    name:"",
    number:"",
    id:null
  })

  const [rowData , setRowData] = useState([])
  const [showBookingTable, setShowBookingTable] = useState(true);
  const [schedule, setSchedule] = useState();
  const selectAppointment = (day, hour , id , item) => {
    setRowData(item)
    setModal((prev) => ({...prev, confirmation: true}));
    setAppointment((prev)=>({...prev ,day:day , hour:hour , id:id}))
  };

  // confirm appointment
  const confirmAppointment = async() => {
    if(!token){
      toast.error(t('plsLoginFirst'))
      setModal((prev) => ({...prev, data: false}));
      setConfirmationLoader(false)
      return
    }
    setConfirmationLoader(true)
    let dataSend = {
      name:appointmentData.name,
      phone:appointmentData.number,
      reason:"test",
      time_slot_id:appointment.id,
      appointment_type_id:2,
      gender:"male",
    }
    try{
      const res = await axios.post(`${base_url}/appointment/book`,dataSend,
        {
          withCredentials: true
        }
      )
      toast.success(res?.data?.message)
      setModal((prev) => ({...prev, success: true}));
    }
    catch(error){
      handleApiError(error)
    }
    finally{
      setConfirmationLoader(false)
      setAppointmentData((prev) => ({...prev, name: "", number: true}));
      setModal((prev) => ({...prev, data: false}));
    }
  };
  
  // cancel appointment
  const CancelAppointment = () => {
    setModal((prev) => ({...prev, data: false}))
    setAppointmentData((prev) => ({...prev, name: "", number: true}));
  };


  // get all appointments
  const getAppointments = async () => {
    const res = await getData(`time-slot`);
    setSchedule(res?.data?.data?.data);
    setTotalDays(res?.data?.data?.paginationMeta?.totalItems)
  };

  // handle next page button in table
  const handleNextPage = ()=>{
    if(lastIndex >= totalDays){
      return
    }
    setStartIndex(startIndex+dayPerPage)
    lastIndex = lastIndex+dayPerPage
  }

  // handle prev page button in table
  const handlePrevPage = ()=>{
    if(startIndex <= 0){
      return
    }
    setStartIndex(startIndex-dayPerPage < 0 ? 0 : startIndex - dayPerPage)
    lastIndex = (lastIndex - dayPerPage)

  }

  useEffect(() => {
    getAppointments();
  }, []);
  return (
    <>
      <ToastContainer />
      <Topbar />
      <Navbar />
      <LandPage header={t('bookAppointment')} link={t('bookAppointment')} href='/booking' />
      <div className='booking-container container'>
        <div className='booking-content content'>
          <div className='tabs'>
            <button
              onClick={() => setShowBookingTable(true)}
              className={showBookingTable ? "active" : null}
            >
              {t('bookAppointment')}
            </button>
            <button
              onClick={() => setShowBookingTable(false)}
              className={!showBookingTable ? "active" : null}
            >
              {t('myAppointment')}
            </button>
          </div>
          {showBookingTable ? (
            schedule ? (
              <>
                  <div className="select-day">
                    <p>{t('numberOfDay')}</p>
                    <select name="" id=""  value={dayPerPage} onChange={(e)=>{setdayPerPage(+e.target.value)}}>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                      <option value="7">7</option>
                    </select>
                  </div>
                <table>
                  <thead> 
                    <tr>
                      <th>{t('time')}</th>
                      {schedule?.slice(startIndex, lastIndex)?.map((item, index) => {
                        return <th key={index}>{item.slot_date}</th>;
                      })}
                    </tr>
                  </thead>
                  <motion.tbody
                     key={startIndex}
                     initial={{translateX: -100, opacity: 0}}
                     animate={{translateX: 0, opacity: 1}}
                     transition={{duration: 0.5}}
                  >
                    {schedule?.[1].slots?.slice(0,7).map((item, index) => {
                      return (
                        <tr key={index}>
                          <td className='hour'>
                            <p>{item.time > 12 ? item.time - 12 : item.time}</p>
                          </td>
                          {schedule?.slice( startIndex , lastIndex )?.map((day, index) => {
                            const slot = day?.slots?.find(
                              (s) => s.time === item.time
                            );
                            return (
                              <td
                                key={index}
                                onClick={() => {
                                  slot?.status === "available" &&
                                    selectAppointment(day.slot_date, item.time , item.id , day);
                                }}
                                className={
                                  slot?.status === "available"
                                    ? "available"
                                    : "booked"
                                }
                              >
                                {slot?.status === "available"
                                  ? t('available')
                                  : t('booked')}
                                {slot?.status !== "available" && (
                                  <Icon icon={<NotAvailable />} />
                                )}
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })}
                  </motion.tbody>
                </table>
                <div className="slider-controls">
                    <button onClick={()=>handlePrevPage()}><AngleRight width="30px"/></button>
                      {Array.from({ length: pageCounter}, (_, i) => 0 + i).map((item)=>{
                        return(
                          // <p onClick={()=>handlePageNumber(item)} className={Math.ceil((startIndex-0)/dayPerPage)== item ?"active":null}>{item+1}</p>
                          <p className={Math.ceil((startIndex-0)/dayPerPage)== item ?"active":null}>{item+1}</p>
                        )
                      })}
                    <button onClick={()=>handleNextPage()}><AngleLeft width="30px" /></button>
                  </div>
              </>
            ) : (
              <Loader />
            )
          ) : (
            <MyAppointments />
          )}

          {/* confirmation modal */}
          <Modal
            isOpen={modal.confirmation}
            onClose={() => setModal((prev) => ({...prev, confirmation: false}))}
            handleCancel={() =>
              setModal((prev) => ({...prev, confirmation: false}))
            }
            AcceptBtn={t('nextStep')}
            handleAdd={() =>setModal((prev) => ({...prev, confirmation: false, data: true}))}
            CancelBtn={t('cancel')}
            showModalsBtns='true'
          >
            <div className='icon'>
              <Check width='70px' color='#1a76d1' />
            </div>
            <h3>{t('confirmBooking')}</h3>
            <div className='bookingInfo'>
              <p style={{textAlign: "center"}}>
                {t('sureBookTime')}
              </p>
              <div>
                <p>
                  <span>{t('date')}</span>: {rowData.slot_date}
                </p>
                <p>
                  <span>{t('time')}</span>:{" "}
                  {appointment.hour > 12
                    ? appointment.hour - 12
                    : appointment.hour}
                </p>
              </div>
            </div>
          </Modal>

          {/* user data collection modal */}
          <Modal
            isOpen={modal.data}
            onClose={() => setModal((prev) => ({...prev, data: false}))}
            handleCancel={CancelAppointment}
            AcceptBtn={t('confirm')}
            handleAdd={confirmAppointment}
            CancelBtn={t('cancel')}
            showModalsBtns='true'
            modalLoader={confirmationLoader}
          >
            <h3>{t('confirmBooking')}</h3>

            <TwoInputs
              typeOne='text'
              valueOne={appointmentData.name}
              fnOne={(e) =>
                setAppointmentData((prev) => ({...prev, name: e.target.value}))
              }
              placeOne={t('enterYourName')}
              typeTwo='number'
              valueTwo={appointmentData.number}
              fnTwo={(e) =>
                setAppointmentData((prev) => ({
                  ...prev,
                  number: e.target.value,
                }))
              }
              placeTwo={t('enterYourNumber')}
            />
          </Modal>

          {/* success modal */}
          {modal.success ? (
            <SuccessModal
              isOpen={modal.success}
              onClose={() => setModal((prev) => ({...prev, success: false}))}
              successMsg={t('appointmentCreated')}
              welcomeMsg={t('waitingForYou')}
            />
          ) : null}
        </div>
      </div>
      <Footer />
    </>
  );
}
export default Booking;
